module.exports = __webpack_public_path__ + "static/media/back.097acd2d.jpeg";